// The admin shell (features/admin/routes.ts) owns the parent `data-integrity`
// path; this sub-feature only exposes the drill-in child segment. Navigation is
// relative (`navigate(hubUuid)` / `navigate('..')`).
export const HUB_DETAIL_SEGMENT = ':hubUuid'
